import {
  deleteApiCaller,
  getApiCaller,
  postFormDataApiCaller,
  putFormDataApiCaller,
  putApiCaller,
} from "../apiCaller";

// A "series" (e.g. برگزیدگان / The Chosen) is a VideoCategory with categoryType='series'.
// Seasons are child categories; episodes are Videos with sourceType='hls'.
// We reuse the existing video-category & video endpoints, scoped with categoryType/sourceType.

// List series-typed categories under a parent (parentId=null => top-level series).
export const getSeriesCategories = async (parentId = null, limit = 100) => {
  const parent = parentId === null ? "null" : parentId;
  const url = `video-category/get-all?categoryType=series&parentId=${parent}&limit=${limit}`;
  return getApiCaller(url);
};

export const getSeriesCategoryById = async (id) => {
  return getApiCaller(`video-category/${id}`);
};

export const addSeriesCategory = async (formData) => {
  return postFormDataApiCaller("video-category/create", formData);
};

export const updateSeriesCategory = async (id, formData) => {
  return putFormDataApiCaller(`video-category/update/${id}`, formData);
};

// Hard delete the category. videoAction: 'delete' (also remove episodes) | 'uncategorize' | 'move'.
export const deleteSeriesCategory = async (id, videoAction = "delete") => {
  return deleteApiCaller(`video-category/delete/${id}`, { videoAction });
};

// Episodes directly inside a category (a season, or the series root if no seasons).
export const getEpisodesByCategory = async (categoryId, page = 1, limit = 100) => {
  return getApiCaller(`video-category/${categoryId}/videos?page=${page}&limit=${limit}`);
};

// Single episode incl. hlsUrl + subtitles (admin only — needed for editing).
export const getEpisodeById = async (id) => {
  return getApiCaller(`video/${id}`);
};

export const addEpisode = async (formData) => {
  return postFormDataApiCaller("video/create", formData);
};

export const updateEpisode = async (id, formData) => {
  return putFormDataApiCaller(`video/update/${id}`, formData);
};

export const deleteEpisode = async (id) => {
  return deleteApiCaller(`video/delete/${id}`);
};

// Most-watched series episodes (total plays + unique viewers). sortBy: 'views' | 'unique'.
export const getMostWatchedEpisodes = async (sortBy = "views", limit = 20) => {
  return getApiCaller(`video/most-watched?sortBy=${sortBy}&limit=${limit}`);
};

export const episodeSequence = async (payload) => {
  return putApiCaller("video/sequence", payload);
};
